import React from "react";
const Reversible = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rettangolo_294"
            data-name="Rettangolo 294"
            width="30"
            height="20.839"
            transform="translate(0 0)"
            fill="none"
            stroke="#D2D2D2"
            stroke-width="1"
          />
        </clipPath>
      </defs>
      <g
        id="Raggruppa_575"
        data-name="Raggruppa 575"
        transform="translate(-1407 -400)"
      >
        <rect
          id="Rettangolo_286"
          data-name="Rettangolo 286"
          width="32"
          height="32"
          transform="translate(1407 400)"
          fill="none"
        />
        <g
          id="Raggruppa_570"
          data-name="Raggruppa 570"
          transform="translate(1408 406)"
          clip-path="url(#clip-path)"
        >
          <path
            id="Tracciato_128"
            data-name="Tracciato 128"
            d="M15,10.313c-1.6,3-4,6-7.54,6a6.24,6.24,0,0,1-6.46-6,6.239,6.239,0,0,1,6.47-6H7.5a8.327,8.327,0,0,1,3.23.68"
            fill="none"
            stroke="#D2D2D2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracciato_129"
            data-name="Tracciato 129"
            d="M15,10.313c1.6-3,4-6,7.54-6a6.24,6.24,0,0,1,6.46,6,6.24,6.24,0,0,1-6.46,6,15.888,15.888,0,0,1-3.23-.68"
            fill="none"
            stroke="#D2D2D2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracciato_130"
            data-name="Tracciato 130"
            d="M8.8,1l2.5,4.33-4.33,2.5"
            fill="none"
            stroke="#D2D2D2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracciato_131"
            data-name="Tracciato 131"
            d="M21.2,19.839l-2.5-4.33,4.33-2.5"
            fill="none"
            stroke="#D2D2D2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Reversible;
